import loadable from "@loadable/component";

import "../style.scss";

const Notification = loadable(() => import(/* webpackChunkName: "Notification" */ "./notification"));
const Searchbar = loadable(() => import(/* webpackChunkName: "Searchbar" */ "./searchbar"));
const MobileSearchbar = loadable(() => import(/* webpackChunkName: "MobileSearchbar" */ "./mobile-searchbar"));
const User = loadable(() => import(/* webpackChunkName: "User" */ "./user"));
const Logo = loadable(() => import(/* webpackChunkName: "Logo" */ "./logo"));
const Authentication = loadable(() => import(/* webpackChunkName: "Authentication" */ "./authentication"));

export {
	Notification,
	Searchbar,
	User,
	Logo,
	MobileSearchbar,
  	Authentication
}